import { all, fork } from 'redux-saga/effects'
import authSaga from '@/sagas/auth'

const rootSaga = function* () {
  yield all([
    fork(authSaga),
  ])
}

export default rootSaga
